var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('vue-page-stack',[_c('router-view',{key:_vm.$route.fullPath,staticClass:"router-view-c"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }